(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8551],{

/***/ 82624:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ IndexView; }
/* harmony export */ });
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(78402);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_index_module_scss__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);




function IndexView(props) {
  var pageKey = props.pageKey,
      _props$menu = props.menu,
      menu = _props$menu === void 0 ? [] : _props$menu,
      title = props.title,
      bgImage = props.bgImage,
      _props$bgImageMobile = props.bgImageMobile,
      bgImageMobile = _props$bgImageMobile === void 0 ? bgImage : _props$bgImageMobile,
      className = props.className;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("section", {
    className: classnames__WEBPACK_IMPORTED_MODULE_0___default()((_index_module_scss__WEBPACK_IMPORTED_MODULE_2___default().container), className),
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
      className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_2___default()["for-pc"]),
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("header", {
        className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_2___default().header),
        style: {
          backgroundImage: "url(".concat(bgImage, ")")
        },
        children: title
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
      className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_2___default()["for-mobile"]),
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("header", {
        className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_2___default().header),
        style: {
          backgroundImage: "url(".concat(bgImageMobile, ")")
        },
        children: title
      })
    }), menu.length > 0 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("nav", {
      className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_2___default().nav),
      children: menu.map(function (item) {
        var key = item.key,
            text = item.text,
            _item$target = item.target,
            target = _item$target === void 0 ? '_self' : _item$target;
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
          className: classnames__WEBPACK_IMPORTED_MODULE_0___default()((_index_module_scss__WEBPACK_IMPORTED_MODULE_2___default().navItem), pageKey === item.key && (_index_module_scss__WEBPACK_IMPORTED_MODULE_2___default().active)),
          target: target,
          rel: "noreferrer",
          href: item.link,
          children: text
        }, key);
      })
    })]
  });
}

/***/ }),

/***/ 53784:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export IndexView */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5951);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_index_module_scss__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var components_button__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89231);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);






var IndexView = function IndexView(props) {
  var className = props.className,
      _props$isTry = props.isTry,
      isTry = _props$isTry === void 0 ? true : _props$isTry,
      _props$btnType = props.btnType,
      btnType = _props$btnType === void 0 ? 'banner' : _props$btnType,
      btnWidth = props.btnWidth;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("section", {
    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_index_module_scss__WEBPACK_IMPORTED_MODULE_4___default().btnGroup), !!className && className),
    children: [isTry && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(components_button__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
      category: btnType,
      btnWidth: btnWidth,
      type: "primary",
      color: "green",
      className: 'btnTry',
      href: "/try",
      children: "\u7ACB\u5373\u8BD5\u7528"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(components_button__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
      category: btnType,
      btnWidth: btnWidth,
      type: "primary",
      href: "/contact",
      children: "\u8054\u7CFB\u9500\u552E"
    })]
  });
};
/* harmony default export */ __webpack_exports__["Z"] = (IndexView);

/***/ }),

/***/ 38732:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Home; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./src/action/index.ts + 2 modules
var action = __webpack_require__(37121);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
;// CONCATENATED MODULE: ./src/utils/download.ts




var downloadFile = /*#__PURE__*/function () {
  var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(id, resourceId, fileName) {
    var preview,
        pathname,
        isSupportCenter,
        res,
        data,
        blob,
        link,
        _args = arguments;
    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            preview = _args.length > 3 && _args[3] !== undefined ? _args[3] : false;
            pathname = window.location.pathname; // 支持中心及新闻

            isSupportCenter = ['tutorial', 'faq', 'news'].some(function (str) {
              return pathname.indexOf(str) > -1;
            });

            if (!isSupportCenter) {
              _context.next = 9;
              break;
            }

            _context.next = 6;
            return action/* action.getResourceForSupportCenter */.a.getResourceForSupportCenter(resourceId);

          case 6:
            res = _context.sent;
            _context.next = 12;
            break;

          case 9:
            _context.next = 11;
            return action/* action.getResource */.a.getResource(id, resourceId);

          case 11:
            res = _context.sent;

          case 12:
            if (!res) {
              _context.next = 24;
              break;
            }

            if (!preview) {
              _context.next = 15;
              break;
            }

            return _context.abrupt("return", res);

          case 15:
            _context.next = 17;
            return axios_default().get(res, {
              responseType: 'arraybuffer'
            });

          case 17:
            data = _context.sent;
            blob = new Blob([data.data]);
            link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = fileName;
            link.click();
            window.URL.revokeObjectURL(link.href);

          case 24:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function downloadFile(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();
// EXTERNAL MODULE: ./node_modules/@xylink/xy-editor/dist/preview.js
var preview = __webpack_require__(80175);
var preview_default = /*#__PURE__*/__webpack_require__.n(preview);
// EXTERNAL MODULE: ./node_modules/@xylink/xy-editor/dist/css/preview.css
var css_preview = __webpack_require__(23831);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/components/preview/index.module.scss
var index_module = __webpack_require__(77448);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/preview/index.tsx



 // import Preview from './preview.js';

 // import './css/preview.css';




function Home(props) {
  var classNames = props.classNames,
      detail = props.detail,
      _props$pdfPreview = props.pdfPreview,
      pdfPreview = _props$pdfPreview === void 0 ? false : _props$pdfPreview,
      _props$isImgView = props.isImgView,
      isImgView = _props$isImgView === void 0 ? true : _props$isImgView;
  var id = detail.id,
      intro = detail.intro,
      viewCount = detail.viewCount,
      content = detail.content,
      releaseTime = detail.releaseTime,
      enclosureList = detail.enclosureList,
      author = detail.author;

  var onDownload = /*#__PURE__*/function () {
    var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(item) {
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              downloadFile(id, item.resourceId, item.resourceName);

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function onDownload(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  var onPreviewPdf = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(item) {
      var url;
      return regenerator_default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return downloadFile(id, item.resourceId, item.resourceName, true);

            case 2:
              url = _context2.sent;
              console.log(url);

              if (typeof url === 'string') {
                window.open(url, '_blanl');
              }

            case 5:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function onPreviewPdf(_x2) {
      return _ref2.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/(0,jsx_runtime.jsx)((preview_default()), {
    isWebsite: true,
    className: classnames_default()((index_module_default()).container, !!classNames && classNames),
    viewCount: viewCount,
    author: author,
    enclosure: enclosureList ? {
      enclosureList: enclosureList,
      onDownloadEnclosure: onDownload,
      onPreviewPdf: pdfPreview ? onPreviewPdf : undefined
    } : undefined,
    releaseTime: releaseTime,
    intro: intro,
    content: content,
    isImgView: isImgView
  });
}

/***/ }),

/***/ 79685:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Home; }
/* harmony export */ });
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var components_layout__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(16569);
/* harmony import */ var components_preview__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(38732);
/* harmony import */ var components_banner__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(82624);
/* harmony import */ var components_contact__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(53784);
/* harmony import */ var constants_index__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(40238);
/* harmony import */ var styles_sales_partner_module_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(65124);
/* harmony import */ var styles_sales_partner_module_scss__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(styles_sales_partner_module_scss__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(85893);









function Home() {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(components_layout__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_0___default()), {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("title", {
        children: "\u4F19\u4F34\u653F\u7B56 - \u5C0F\u9C7C\u6613\u8FDE-\u5B98\u7F51-\u8BA9\u4E16\u754C\u96F6\u8DDD\u79BB"
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("section", {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(components_banner__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        title: "\u5408\u4F5C\u4F19\u4F34",
        bgImage: constants_index__WEBPACK_IMPORTED_MODULE_5__/* .partnerBanner */ .X4,
        bgImageMobile: constants_index__WEBPACK_IMPORTED_MODULE_5__/* .partnerBannerMobile */ .kK
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(components_preview__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        isImgView: false,
        classNames: (styles_sales_partner_module_scss__WEBPACK_IMPORTED_MODULE_7___default().content),
        detail: {
          id: '1',
          content: '<h4>伙伴政策</h4>\n<p>随着4G网络的普及和5G的快速发展，移动视频时代已经到来。移动视频应用深入各行各业，消除时间与空间的限制，改变企业沟通方式， 创造新的商业模式。远程银行、远程医疗、远程教育和视频客服成为现实。</p>\n<p>企业视频会议市场飞速增长，&ldquo;SaaS云服务+智能视频硬件&rdquo;视频应用新模式成为新的&ldquo;蓝海&rdquo;。小鱼易连依托专业的音视频技术、创新的智能硬件、全球部署的云服务与极简用户体验，秉承“建设有核心自主知识产权的高科技民族企业”的使命，用科技振兴民族，让世界零距离。</p>\n<p>全面分销、伙伴共赢，小鱼易连愿与合作伙伴共享千亿级移动视频应用市场。</p>\n<h4>支持政策</h4>\n<p>市场体验支持：市场费用分担、体验中心支持、市场工具支持</p>\n<p>业务开展支持：销售工具支持、战略项目支持、批量客户定制、商机信息推送</p>\n<p>管理运营支持：运营方案指导、核心伙伴年会、业务经营规划</p>\n<h4>合作热线</h4>\n<p>400-900-3567</p>'
        }
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(components_contact__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {})]
    })]
  });
}

/***/ }),

/***/ 13456:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/partner",
      function () {
        return __webpack_require__(79685);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 78402:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"banner_container__oBe7a","nav":"banner_nav__R4D9K","navItem":"banner_navItem__z8je4","header":"banner_header__8mEeU","border__px":"banner_border__px__Rkq8K","border__px-before":"banner_border__px-before__jqV1R","border__px-before1":"banner_border__px-before1__rZGud","border-children1":"banner_border-children1__cwgjz","border-children2":"banner_border-children2__7N7DQ","for-mobile":"banner_for-mobile__9iMXJ","for-pc":"banner_for-pc__zlWnK","active":"banner_active___c3ly"};

/***/ }),

/***/ 5951:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"border__px":"contact_border__px__DM3ZN","border__px-before":"contact_border__px-before__F0Vlr","border__px-before1":"contact_border__px-before1__wOrFT","border-children1":"contact_border-children1__bFQeI","border-children2":"contact_border-children2__8WMsP","for-mobile":"contact_for-mobile__SdQT9","for-pc":"contact_for-pc__7iuGe","btnGroup":"contact_btnGroup__Glj3p"};

/***/ }),

/***/ 77448:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"preview_container__Yt65c","border__px":"preview_border__px__y0WDs","border__px-before":"preview_border__px-before__hSj6I","border__px-before1":"preview_border__px-before1__4Y1Em","border-children1":"preview_border-children1__BW1YI","border-children2":"preview_border-children2__8gbEe","for-mobile":"preview_for-mobile__rsD_r","for-pc":"preview_for-pc__ER2pR"};

/***/ }),

/***/ 65124:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"content":"partner_content__5IqJD"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5259,1747,4662,7115,7602,2178,4569,9774,2888,179], function() { return __webpack_exec__(13456); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);